import { useState } from "react";
import useSWR from "swr";
import { fetcher } from "../../../../services/fetcher";
import { Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import ViewEditTraveller from "../../forms/ViewEditTraveller/ViewEditTraveller";
import MainLoader from "../../../../common/components/Loader/Loader";
import {
  successNotifications,
  errorNotifications,
} from "../../../../utils/handleNotifications";

const Endorsement = () => {
  const { id } = useParams();
  const endpoint = `issuance/travellers/${id}/`;
  const [isEditing, setIsEditing] = useState(false);
  const { data, isLoading, error, mutate } = useSWR(endpoint, fetcher);

  const handleSubmit = async (updatedData) => {
    if (Object.keys(updatedData).length === 0) {
      setIsEditing(false);
      return;
    }

    try {
      await fetcher(endpoint, "PUT", updatedData);
      await mutate();
      setIsEditing(false);
      successNotifications("Traveller endorsement detail has been updated");
    } catch (error) {
      console.error("Error updating traveller:", error);
      errorNotifications(error);
    }
  };

  if (isLoading) return <MainLoader />;
  if (error) return <Text c="red">Error loading traveller details</Text>;

  return (
    <ViewEditTraveller
      data={data ? data[0] : {}}
      onSubmit={handleSubmit}
      isEditing={isEditing}
      setIsEditing={setIsEditing}
    />
  );
};

export default Endorsement;
